import http from "@/utils/axios";

export default {
  namespaced: true,
  state: {
    diseases: null,
  },
  getters: {
    getAllDiseases: (state) => state.diseases,
    getDiseaseById: (state) => (id) =>
      state.diseases?.find((disease) => disease.id === id),
  },
  mutations: {
    setAllDiseases(state, diseases) {
      state.diseases = diseases;
    },
  },
  actions: {
    async fetchDiseases({ commit }) {
      const response = await http.get("/doctor/diseases");
      const diseases = response.data;
      commit("setAllDiseases", diseases);
    },
  },
};
